import utils from 'helpers/utils';
import {useServiceStatus} from 'stores/hooks/service';
import {useServiceApiMutation, useServiceApiQuery} from 'stores/hooks/query';

const path = utils.servicePath(import.meta.url);

export function usePortalClientStatus () {
  return useServiceStatus(path);
}

export function usePortalClientGet ({clientId}, queryOptions = {}) {
  return useServiceApiQuery(path, 'get', {clientId}, queryOptions);
}

// other
export function usePortalClientWarmup (mutationOptions = {}) {
  return useServiceApiMutation(path, 'post', {}, {
    overridePath: 'portal/clients/:clientId/warmup?teamId=:teamId',
    hasInvalidData: true,
    ...mutationOptions
  });
}
